import React, { useEffect } from 'react'

import { useReportSearch } from '@/components/feature/analytics/hooks/use-report-search'
import CreatorList from '@/components/shared/creator-list'
import Page from '@/components/shared/page'
import { FeatureKey } from '@/constants/feature-key'
import { readAllCreators } from '@/redux/creator-actions'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'

import FansReportsForCreator from './components/fans-reports/fans-reports-for-creator'
import s from './fans-reports.module.css'

export default function FansReportsPage() {
  const creatorId = useAppSelector((state) => state.creator.selectedCreatorId)
  const dispatch = useAppDispatch()
  const {
    searchValues,
    searchElements,
  } = useReportSearch({ enableEarningTypeSelect: true })

  useEffect(() => {
    void dispatch(readAllCreators({ permissionKey: FeatureKey.FansReports }))
  }, [dispatch])

  return (
    <Page
      contentClassName={s.fanReportsContent}
      headerRight={searchElements}
      sider={<CreatorList />}>
      {creatorId &&
        <FansReportsForCreator
          creatorId={creatorId}
          searchValues={searchValues}
        />}
    </Page>
  )
}
